import React from 'react';
import { TOptions } from 'i18next';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';

interface IProps {
	onConsentEvent: () => void;
	description: string;
	translationOptions?: TOptions;
}

export const ModalSentErrorNew: React.FC<IProps> = ({ onConsentEvent, description, translationOptions }) => (
	<div className="absolute inset-0 flex items-center justify-center" data-test="ModalSentErrorIsVisible">
		<div className="w-full max-w-120 p-8 rounded flex flex-col items-center gap-6 bg-white-00-new shadow-500">
			<Icon name={IconName.errorLarge} size="hero" className="text-red-03-new" />
			<Text
				className="w-full"
				translationNameSpace="modals"
				translationKey={description}
				translationOptions={translationOptions}
				size="xl"
				weight="bold"
				align="center"
			/>
			<NewButton
				variant="primary"
				color="purple"
				size="small"
				type="submit"
				testId="okButton"
				onClick={onConsentEvent}>
				<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
			</NewButton>
		</div>
	</div>
);
